module.exports = "<div *ngIf=\"info\" style=\"padding:20px;\">\n<p style=\"font-size:14px;\"><i [innerHTML]=\"info\"></i></p>\n</div>\n"